import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import InstagramProfilesService from '@/services/InstagramProfilesService';

function _resolveParams(given = {}, state) {
  return {
    page: given.page !== undefined ? given.page : state.currentPage,
    size: given.size !== undefined ? given.size : state.pageSize,
    search: given.search !== undefined ? given.search : state.search,
    sortBy: given.sortBy !== undefined ? given.sortBy : state.sortBy,
    sortOrder: given.sortOrder !== undefined ? given.sortOrder : state.sortOrder,
  };
}

export async function fetchProfiles({ commit, state }, params = {}) {
  const { page: currentPage, size: currentSize, search: currentSearch, sortBy: currentSortBy, sortOrder: currentSortOrder } = _resolveParams(params, state);

  commit(MUTATE_MULTIPLE, [
    { property: 'loading', with: true },
    { property: 'error', with: null },
  ]);

  try {
    const data = await InstagramProfilesService.getProfiles({ page: currentPage, size: currentSize, search: currentSearch, sortBy: currentSortBy, sortOrder: currentSortOrder });
    commit(MUTATE_MULTIPLE, [
      { property: 'profiles', with: data.content },
      { property: 'totalElements', with: data.total_elements },
      { property: 'totalPages', with: data.total_pages },
      { property: 'currentPage', with: data.page },
      { property: 'pageSize', with: data.size },
      { property: 'search', with: currentSearch },
      { property: 'sortBy', with: currentSortBy },
      { property: 'sortOrder', with: currentSortOrder },
    ]);
  } catch (err) {
    commit(MUTATE, { property: 'error', with: err });
  } finally {
    commit(MUTATE, { property: 'loading', with: false });
  }
}

export async function deleteProfiles({ commit, dispatch, state }, ids = []) {
  commit(MUTATE_MULTIPLE, [
    { property: 'loading', with: true },
    { property: 'error', with: null },
  ]);

  try {
    await InstagramProfilesService.deleteProfiles(ids);
    commit(MUTATE, { property: 'selectedIds', with: [] });
    await dispatch('fetchProfiles', { page: state.currentPage, size: state.pageSize });
  } catch (err) {
    commit(MUTATE, { property: 'error', with: err });
    commit(MUTATE, { property: 'loading', with: false });
    throw err;
  }
}

export async function createProfile({ dispatch, state }, profileData) {
  try {
    await InstagramProfilesService.createProfile(profileData);
    await dispatch('fetchProfiles', { page: state.currentPage, size: state.pageSize });
  } catch (err) {
    throw err;
  }
}

export async function createBatch(_context, entries = []) {
  return InstagramProfilesService.createBatch(entries);
}
